import React from 'react';
import { PublicNav } from './ui/AppShell';

function Navbar() {
  return <PublicNav />;
}

export default Navbar
